import {
  getSafeUrl,
  useGetSystemDataQuery,
  useUserSessionCheckQuery
} from '@monorepo/shared';
import AnimationOnScroll from '@monorepo/shared/components/AnimationOnScroll';
import { Check } from '@rsuite/icons';
import { CSSProperties, useEffect, useState } from 'react';
import { BsCircleFill } from 'react-icons/bs';
import { Button, Carousel, Divider, Stack } from 'rsuite';
import { host, EnvConst, server } from '../../config/const';
// import cloudLog from '../../images/header/FAZ_cloud.svg';
import {
  cloudLog,
  benefits,
  prod,
  reviews,
  useCase,
  whatIsNew
} from './homeCons';
const Home = () => {
  const { data: systemData, isSuccess: dataSuccess } = useGetSystemDataQuery({
    server: server
  });
  const [privacyUrl, setPrivacyUrl] = useState<string>('');
  const [releaseNoteUrl, setReleaseNoteUrl] = useState<string>('');
  const { data: sessionData } = useUserSessionCheckQuery({
    server: server
  });
  useEffect(() => {
    if (dataSuccess && systemData) {
      const data: Record<string, any> = systemData;
      setPrivacyUrl(data?.privacy_url);
      setReleaseNoteUrl(data?.release_note_url);
    }
  }, [dataSuccess, systemData]);

  useEffect(() => {
    if (sessionData?.active) {
      login();
    }
  }, [sessionData]);

  const login = () => {
    if (window) {
      window.open(
        getSafeUrl(
          `${EnvConst.auth_host}/ssologin/?next=${host}/login-redirect`
        ),
        '_self'
      );
    }
  };

  const register = () => {
    if (window) {
      window.open(getSafeUrl(`${EnvConst.registerUrl}`), '_self');
    }
  };

  const goToPremium = () => {
    if (window) {
      window.open(getSafeUrl(prod?.links?.goToPremium), '_blank');
    }
  };
  const goToVideo = () => {
    if (window) {
      window.open(getSafeUrl(prod?.links?.goToVideo), '_blank');
    }
  };

  const goToMore = () => {
    if (window) {
      window.open(
        getSafeUrl(prod?.links?.goToMore),
        '_blank' // <- This is what makes it open in a new window.
      );
    }
  };
  return (
    <div className="home-page-container">
      <div className="nav-hoc">
        <div className="nav-content">
          <div className="header-logo">
            <img
              src={cloudLog}
              width="45"
              style={{ filter: 'invert(1)' }}
            ></img>
            <span style={{ marginLeft: '6px' }}>{prod?.name}</span>
          </div>
          <div className="header-links">
            <a className="header-link" onClick={login}>
              Log in
            </a>
          </div>
        </div>
      </div>

      <div className="main">
        <div className="slp-container introduce">
          <div className="slp-content">
            <section className="title-container">
              <div className="title-content">
                <div className="title">
                  <h1>{prod?.name}</h1>
                  <p className="main-text">{prod?.desc}</p>
                  <Stack className="actions" spacing={32}>
                    <Button
                      appearance="link"
                      className="watch-demo underline-btn"
                      onClick={goToVideo}
                    >
                      {`What is ${prod?.name}?`}
                    </Button>
                  </Stack>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="slp-container banner">
          <div className="slp-content">
            <div className="what-is-new">
              <div className="what-is-new-title">
                <div className="core-title">
                  <span>
                    {`What's new in ${prod?.name}?`}
                    <br />
                    <b>{'Get our latest version'}</b>
                  </span>
                </div>
                <div className="sub-title">{whatIsNew?.desc}</div>
                <Stack direction="column" spacing={12} alignItems="flex-start">
                  {whatIsNew?.links?.length ? (
                    whatIsNew.links.map(
                      (obj: Record<string, string>, index: number) => (
                        <Button
                          key={index}
                          appearance="link"
                          className="read-more-link underline-btn"
                          onClick={() => {
                            window &&
                              window.open(getSafeUrl(obj?.link), '_blank');
                          }}
                        >
                          <span className="link-desc">{obj?.title}</span>
                        </Button>
                      )
                    )
                  ) : (
                    <></>
                  )}
                </Stack>
              </div>
            </div>
          </div>
        </div>

        <div className="slp-container four-tiles">
          <div className="slp-content">
            <div className="slp-header light-text">
              <h1 className="slp-header-title">
                {'Supercharge your protection'}
              </h1>
              <p className="slp-header-subtitle">
                {`${prod?.name} gives you advanced tools to protect and optimize your digital life`}
              </p>
            </div>
            {/* <div className="usecase">
              {useCase?.length ? (
                useCase.map((obj: Record<string, any>, idx: number) => (
                  <a className="usecase-card" key={idx}>
                    <div className="card-header">{obj?.title}</div>
                    <div className="card-desc">{obj?.desc}</div>
                    <div
                      className="card-body"
                      style={{ '--bg-color': obj?.color } as CSSProperties}
                    >
                      <div className="usecase-items">
                        <div className="card-bullets">
                          {obj?.features?.length ? (
                            obj?.features.map((item: string, i: number) => (
                              <div className="bullet-row" key={i}>
                                <div className="bullet-icon">
                                  <BsCircleFill
                                    style={{ fontSize: '8px' }}
                                  ></BsCircleFill>
                                </div>
                                <p>{item}</p>
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <Divider className="body-divider"></Divider>
                      <div className="body-result">
                        <div className="card-bullets">
                          {obj?.results?.length ? (
                            obj?.results.map((item: string, j: number) => (
                              <div className="bullet-row" key={j}>
                                <div className="bullet-icon">
                                  <Check className="icon" />
                                </div>
                                <p>{item}</p>
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </a>
                ))
              ) : (
                <></>
              )}
            </div> */}
          </div>
        </div>

        {/* <div className="slp-container circle">
          <div className="slp-content">
            <div className="slp-header dark-text">
              <h1 className="slp-header-title">
                {'Get security, privacy, and performance tips.'}
              </h1>
            </div>
            <div className="benefits">
              {benefits?.length ? (
                benefits.map((obj: Record<string, any>, index: number) => (
                  <AnimationOnScroll
                    animate="fade-up"
                    className="benefit-container"
                    key={index}
                  >
                    <div className="benefit-header">
                      <div className="benefit-icon">
                        <img src={obj?.icon} />
                      </div>
                      <div className="benefit-title">{obj?.text}</div>
                    </div>
                    <div className="benefit-content">{obj?.desc}</div>
                  </AnimationOnScroll>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </div> */}
      </div>
      <footer className="base-footer">
        <div className="container">
          <div className="footer-logo">
            <i className="icon-prelogin-fortinet"></i>
          </div>
          <div className="footer-bottom">
            <div className="footer-links">
              <div className="link-wrapper">
                <a
                  href="/FortiSandbox-Cloud-Service-Description.pdf"
                  target="_blank"
                >
                  Terms of Service
                </a>
              </div>
              <div className="link-wrapper">
                <a href={privacyUrl} target="_blank">
                  Privacy Policy
                </a>
              </div>
              <div className="link-wrapper">
                <a href={releaseNoteUrl} target="_blank">
                  Release Notes
                </a>
              </div>
            </div>
            <div className="footer-copy">
              {`Copyright © ${new Date().getFullYear()} Fortinet, Inc. All Rights Reserved`}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
